// ─── Angular Imports ───────────────────────────────────────────────────────────
import { Component, DestroyRef, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

// ─── Application Imports ───────────────────────────────────────────────────────
import { IProduct, ProductSearch } from 'src/app/models/products/product';
import { AuthService } from 'src/app/services/auth.service';
import { Permission } from 'src/app/constants/permission.constant';
import { ProductsService } from 'src/app/services/products.service';
import { SignalrService } from 'src/app/services/signalr.service';
import { SignalrGroup } from 'src/app/services/signalr-group';
import { SignalRStaticGroups } from 'src/app/constants/signalr.constant';
import { updateRecentlyList } from 'src/app/utils/recentlyList';

@Component({
    selector: 'app-shoots-latest',
    templateUrl: './shoots-latest.component.html',
    styleUrls: ['./shoots-latest.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class ShootsLatestComponent implements OnInit, OnDestroy {
  // ─── State ───────────────────────────────────────────────────────────────────
  private readonly destroyRef = inject(DestroyRef);
  Permission = Permission;
  recentlyShotList: IProduct[] = [];

  // ─── Constructor ─────────────────────────────────────────────────────────────
  constructor(
    private productService: ProductsService,
    private router: Router,
    public authService: AuthService,
    private signalrService: SignalrService,
  ) {}

  // ─── Lifecycle Hooks ────────────────────────────────────────────────────────
  ngOnInit(): void {
    if (!this.authService.hasPermission(Permission.ShootAssetsRead)) {
      return;
    }

    this.getRecentlyShot();

    SignalrGroup.join({
      signalrService: this.signalrService,
      destroyRef: this.destroyRef,
      group: SignalRStaticGroups.ProductsShot,
      data$: this.signalrService.productsShotData,
      onData: (data: ProductSearch) => {
        this.recentlyShotList = updateRecentlyList(this.recentlyShotList, data);
      },
    });
  }

  ngOnDestroy(): void {
    this.signalrService.clearProductsShot();
  }

  // ─── Data Fetching Methods ──────────────────────────────────────────────────
  getRecentlyShot(): void {
    this.productService
      .searchByCode(undefined, undefined, 7, undefined, undefined, 'RecentlyShot')
      .subscribe((res) => {
        this.recentlyShotList = res.results;
      });
  }

  // ─── Action Methods ─────────────────────────────────────────────────────────
  viewMore(filter: string): void {
    this.router.navigateByUrl(`product-filter?key=${filter}`);
  }
}
